import buildFormData, { FormParams } from "@utils/buildFormData";
import { PostRequest } from "./http/BaseRequest";

export const USER_META_VERSION_240531 = "240531";

export const CURRENT_META_VERSION = USER_META_VERSION_240531;

export type LocationOrderTable = {[key: string]: string[]};
export interface UserMeta {
  Version?: string; //lexicographically ordered
  LocationBuildingsOrder?: LocationOrderTable;
}

export interface EditUserParams {
  name?: string;
  email?: string;
  private_email?: boolean;
  avatar?: Blob;
  telegram_username?: string;
  private_telegram?: boolean;
  about?: string;
  notification_emails?: string;
  password?: string;
  repete_password?: string;
  entered_password?: string;
  summary_email?: boolean;
  summary_telegram?: boolean;
  twofa?: boolean;
  meta?: UserMeta | string;
}
/*
export const edit = (props: EditUserPropsI): Promise<AxiosResponse<ServerResponse> | Error> => {
  const formd = buildFormData(props as unknown as FormParams);
  return service.api.post("/user/change_info", formd);
};*/

export class EditUserInfoRequest extends PostRequest {
  constructor(params : EditUserParams) {
    if (typeof params.meta === "object") {
      params.meta = JSON.stringify(params.meta);
    }
    super("/user/change_info", buildFormData(params as unknown as FormParams));
  }
}
